export default __webpack_public_path__ + "static/media/ENTJ-4.0c03f9eb.png";